import { z } from "zod";

// Nested purchaser object from backend
export const PurchaserSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string().nullable().optional(),
  mobile: z.string().nullable().optional(),
});

export const ResubmissionSchema = z.object({
  id: z.number(),
  message: z.string(),
  orderId: z.number(),
  requestedAt: z.string(),
  requestedBy: PurchaserSchema
})

export const ResubmissionEntitySchema = z.object({
  id: z.number(),
  name: z.string(),
  orderNumber: z.string().nullable().optional(),
  // ⬇️ backend now returns nested purchaser, not purchaserName
  purchaser: PurchaserSchema,
  // (compat) allow older code paths that still read purchaserName
  purchaserName: z.string().optional(),

  productCount: z.number(),
  orderSourceFile: z.string(),
  memo: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
  resubmissions: z.array(ResubmissionSchema),
});

export type resubmissionEntity = z.infer<typeof ResubmissionEntitySchema>;
export const GetResubmissionResponseSchema = z.array(ResubmissionEntitySchema);
export type GetResubmissionResponse = z.infer<typeof GetResubmissionResponseSchema>;